import fetch from '@/apiconfig/index';

export function emolumentDetailGetUserRecently(parameter) {
  return fetch({
    url: '/api/emolument/emolumentDetail/getUserRecently',
    method: 'get',
    params: parameter
  });
}
export function emolumentDetailGetInfo(id) {
  return fetch({
    url: '/api/emolument/emolumentDetail/getInfo/'+id,
    method: 'get',
  });
}
export function emolumentGetList(parameter) {
  return fetch({
    url: '/api/emolument/emolumentDetail/getList',
    method: 'get',
    params: parameter
  });
}

export function getOcompanyBalance() {
  return fetch({
    url: '/api/emolument/virtualAccountRecord/getBalanceByAccount',
    method: 'get'
  });
}

export function getAccount() {
  return fetch({
    url: '/api/companystaff/employeeBankCard/findAlipayListByActiveUser',
    method: 'get'
  });
}

export function getEmployeeAccount() {
  return fetch({
    url: '/api/companystaff/employeeBankCard/getEmployeeAccount',
    method: 'get'
  });
}

export function tranGetList(parameter) {
  return fetch({
    url: '/api/emolument/virtualAccountRecord/getList',
    method: 'get',
    params: parameter
  });
}
//校验并且提现
export function checkAndCash(obj) {
  return fetch({
    url: '/api/emolument/virtualAccountRecord/checkAndCash',
    method: 'patch',
    data: obj
  });
}

//校验并且提现
export function checkCode(obj) {
  return fetch({
    url: '/api/emolument/virtualAccountRecord/checkCode',
    method: 'patch',
    data: obj
  });
}
//校验提取金额 以及余额
export function checkCashAmount(obj) {
  return fetch({
    url: '/api/emolument/virtualAccountRecord/checkCashAmount',
    method: 'patch',
    data: obj
  });
}


//保存薪资详情上传的凭证
export function employeeSetSalaryVoucher(parameter) {
    return fetch({
        url: '/api/emolument/emolumentDetail/setEmployeeSetSalaryVoucher',
        method: 'patch',
        data: parameter
    });
}

//删除凭证
export function delSalaryVoucher(parameter) {
    return fetch({
        url: '/api/emolument/emolumentDetail/delSalaryVoucher',
        method: 'patch',
        data: parameter
    });
}

export function sendVerifySms(mobile) {
  return fetch({
    url: '/api/emolument/emolument/sendVerifySms/' + mobile,
    method: 'get'
  });
}
export function sendUserVerifySms(mobile) {
  return fetch({
    url: '/api/emolument/emolument/sendUserVerifySms/' + mobile,
    method: 'get'
  });
}
